import './scss/index.scss';
import { dcFactory } from 'dc';
import VideoComponent from './js/video-play';

dcFactory.register(VideoComponent);
